/**
 * Created by jax.luo on 2016/8/15.
 */
angular.module('dpw.components')
    .directive('dpwEditor', ['markdownUtils', 'helpers', function (markdownUtils, helpers) {
        'use strict';

        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, element, attrs, ngModel) {

                var editor = initEditor(element[0]);
                var $textarea = $(editor.elements);

                ngModel.$render = function () {
                    var content = ngModel.$viewValue || '';
                    renderView(content);
                    toggleEditorPlaceHolder(!content);
                };

                editor.subscribe('editableInput', function () {

                    // fix bug: remove empty blockquote
                    $textarea.find("blockquote").filter(function () {
                        return $(this).text().trim() === "";
                    }).remove();

                    // convert html to markdown then remove html tag from markdown
                    var md = markdownUtils.html2Md(editor.getContent());

                    var mdObj = normalizeMd(md);

                    // limit number of characters
                    if (mdObj.isTextExceeded) {
                        renderView(mdObj.text);

                        placeCaretAtEnd(editor.elements[0]);
                    }

                    scope.$evalAsync(function () {
                        ngModel.$setViewValue(mdObj.text);
                    });

                    toggleEditorPlaceHolder(!mdObj.text);
                });

                if (attrs.editorPlaceholderClass) {
                    editor.subscribe('focus', function () {
                        toggleEditorPlaceHolder(false);
                    });

                    editor.subscribe('blur', function () {
                        var md = markdownUtils.html2Md(editor.getContent());
                        if (!md) {
                            toggleEditorPlaceHolder(true);
                        }
                    });
                }

                // handle unexpected html
                $(editor.elements).on('DOMNodeInserted', function (event) {

                    var target = event.target;

                    // remove unexpected span
                    if (target.tagName === 'SPAN' || target.tagName === 'FONT') {
                        removeOuterTag(target);
                    }

                    // remove unexpected style attribute
                    if ($(target).attr("style")) {
                        $(target).removeAttr("style");
                    }

                    function removeOuterTag(element) {
                        if (element.parentElement) {
                            element.outerHTML = element.innerHTML;
                        }
                    }
                });

                function initEditor(element) {
                    var anchor = {
                        name: "anchor",
                        contentDefault: '<b></b>',
                        classList: ['anchor']
                    };

                    // use custom buttons instead of default buttons to make the editor can't apply multiple buttons to one text
                    // the custom buttons are h1, h2, h3, quote, orderedlist, unorderedlist
                    var headingDisabledButtons = ['dpwOrderedlist', 'dpwUnorderedlist', 'dpwQuote'];
                    var DPWH1 = CreateDPWMediumButton('dpwH1', 'append-h1', ['h1'], '<b>H1</b>', null, headingDisabledButtons);
                    var DPWH2 = CreateDPWMediumButton('dpwH2', 'append-h2', ['h2'], '<b></b>', ['heading'], headingDisabledButtons);
                    var DPWH3 = CreateDPWMediumButton('dpwH3', 'append-h3', ['h3'], '<b></b>', ['heading'], headingDisabledButtons);

                    var quoteDisabledButtons = ['dpwH2', 'dpwH3', 'dpwOrderedlist', 'dpwUnorderedlist'];
                    var DPWQuote = CreateDPWMediumButton('dpwQuote', 'append-blockquote', ['blockquote'], '<b></b>', ['quote'], quoteDisabledButtons);

                    var listDisabledButtons = ['dpwH2', 'dpwH3', 'dpwQuote'];
                    var DPWOrderedlist = CreateDPWMediumButton('dpwOrderedlist', 'insertorderedlist', ['ol'], '<b></b>', ['orderedlist'], listDisabledButtons);
                    var DPWUnorderedlist = CreateDPWMediumButton('dpwUnorderedlist', 'insertunorderedlist', ['ul'], '<b></b>', ['unorderedlist'], listDisabledButtons);

                    var editor = new MediumEditor(element, {
                        placeholder: false,
                        targetBlank: true,
                        autoLink: true,//fix IE auto-link bug, enable auto-link but override it
                        elementsContainer: element.parentElement,
                        toolbar: {
                            diffLeft: RCDPW.isAdminSite ? -400 : 0,
                            buttons: ['dpwH2', 'dpwH3', 'bold', 'italic', 'dpwOrderedlist', 'dpwUnorderedlist', anchor, 'dpwQuote']
                        },
                        extensions: {
                            'auto-link': {},//fix IE auto-link bug: override auto-link
                            // dpwH1: new DPWH1(),
                            dpwH2: new DPWH2(),
                            dpwH3: new DPWH3(),
                            dpwOrderedlist: new DPWOrderedlist(),
                            dpwUnorderedlist: new DPWUnorderedlist(),
                            dpwQuote: new DPWQuote()
                        },
                        anchor: {
                            linkValidation: true
                        },
                        anchorPreview: {
                            hideDelay: 0
                        }
                    });

                    return editor;
                }

                function CreateDPWMediumButton(name, action, tagNames, contentDefault, classList, exclusiveButtons) {
                    return MediumEditor.extensions.button.extend({
                        name: name,
                        action: action,
                        contentDefault: contentDefault,
                        classList: classList,
                        tagNames: tagNames,
                        exclusiveButtons: exclusiveButtons || [],
                        init: function () {
                            MediumEditor.extensions.button.prototype.init.call(this);
                        },
                        handleClick: function (event) {
                            event.preventDefault();
                            event.stopPropagation();

                            var action = this.getAction();
                            if (!action) {
                                return;
                            }

                            var editor = this.base;
                            var tagsBeforeAction = getAppliedTags();

                            var currentExclusiveButton = getExclusiveButton(editor, this.exclusiveButtons);
                            if (currentExclusiveButton) {
                                // if applied and exclusive button exists, need to fix tagBeforeAction and cancel applying manually
                                cancelApplyingButton(currentExclusiveButton);
                            }

                            this.execAction(action);

                            // editor bug: set button active manually
                            var currentNode = getActualElement(editor.getSelectedParentElement());
                            if (!this.isActive() && this.isAlreadyApplied(currentNode)) {
                                this.setActive();
                            }

                            // editor bug: if action is "blockquote" but didn't work, execute action manually
                            executeBlockQuote(this, tagsBeforeAction);
                        }
                    });


                    function getActualElement(node) {
                        if (!node) {
                            return;
                        }

                        // if tag is li, the true element should be ul or ol
                        // if tag is p, should be its parent
                        while (node.tagName === 'LI' || node.tagName === "P") {
                            node = node.parentElement;
                        }

                        return node;
                    }

                    function executeBlockQuote(extension, tagsBeforeAction) {
                        // editor bug: if action is "blockquote" but didn't work, execute action manually
                        var quoteTag = 'blockquote';
                        var appliedTags = getAppliedTags();

                        if (extension.getAction() === 'append-blockquote' &&
                            tagsBeforeAction.indexOf(quoteTag) < 0 &&
                            appliedTags.indexOf(quoteTag) < 0) {

                            document.execCommand('formatBlock', false, "BLOCKQUOTE");
                            extension.setActive();

                        }
                    }

                    function getAppliedTags() {
                        var $appliedButtons = $(editor.getExtensionByName('toolbar').toolbar).find("." + editor.options.activeButtonClass);

                        var actionTagsDic = {
                            "append-h1": ["h1"],
                            "append-h2": ["h2"],
                            "append-h3": ["h3"],
                            "bold": ["b", "strong"],
                            "italic": ["i", "em"],
                            "insertorderedlist": ["ol"],
                            "insertunorderedlist": ["ul"],
                            "createLink": ["a"],
                            "append-blockquote": ["blockquote"]
                        };
                        var appliedTags = _.map($appliedButtons, function (button) {
                            return actionTagsDic[$(button).data("action")];
                        });

                        if (appliedTags.length > 0) {
                            appliedTags = appliedTags.reduce(function (a, b) {
                                return a.concat(b);
                            });
                        }

                        return appliedTags;
                    }

                    function getExclusiveButton(editor, exclusiveButtons) {
                        var $appliedButtons = $(editor.getExtensionByName('toolbar').toolbar).find("." + editor.options.activeButtonClass);
                        var currentTag = getActualElement(editor.getSelectedParentElement()).tagName.toLowerCase();

                        return _.find(exclusiveButtons, function (button) {
                            var ext = this.getExtensionByName(button);
                            var extAction = ext.getAction();

                            // fix currentTag: when applied multiple buttons to one text, currentTag maybe wrong, need to fix
                            var appliedButton = _.find($appliedButtons, function (appliedButton) {
                                return $(appliedButton).data('action') === extAction;
                            });

                            if (appliedButton && $(appliedButton).data('action') === extAction) {
                                currentTag = ext.tagNames[0];
                            }

                            return ext.tagNames.indexOf(currentTag) > -1;

                        }.bind(editor));
                    }

                    function cancelApplyingButton(button) {
                        // if applied and exclusive button exists, need to fix tagBeforeAction and cancel applying manually
                        var exclusiveExt = editor.getExtensionByName(button);

                        // only chrome and safari need expand selection if not select all lines.
                        if (helpers.isChrome() || helpers.isSafari()) {
                            expandSelectionToParent();
                        }

                        editor.execAction(exclusiveExt.getAction());

                        function expandSelectionToParent() {
                            // for ol or ul, the selection must select whole node
                            if (['dpwH2', 'dpwH3', 'dpwOrderedlist', 'dpwUnorderedlist', 'dpwQuote'].indexOf(name) > -1) {
                                var sel = window.getSelection();
                                var range = document.createRange();
                                range.selectNode(getActualElement(editor.getSelectedParentElement()));
                                sel.removeAllRanges();
                                sel.addRange(range);
                            }
                        }
                    }
                }


                function renderView(text) {
                    if (editor) {
                        editor.setContent(markdownUtils.md2Html(text));
                    }
                }

                function toggleEditorPlaceHolder(addClass) {
                    if (attrs.editorPlaceholderClass) {
                        element.toggleClass(attrs.editorPlaceholderClass, addClass);
                    }
                }


                function normalizeMd(mdString) {

                    var maxlength = parseInt(attrs.maxlength, 10);
                    var isTextExceeded = mdString && mdString.length > maxlength;

                    if (isTextExceeded) {
                        mdString = mdString.substr(0, maxlength);
                    }

                    return {
                        isTextExceeded: isTextExceeded,
                        text: mdString
                    };
                }


                // From http://stackoverflow.com/questions/1125292/how-to-move-cursor-to-end-of-contenteditable-entity
                function placeCaretAtEnd(ele) {
                    var lastChildElement = $(ele).children().last().get(0);

                    var range = document.createRange();
                    range.selectNodeContents(lastChildElement);
                    range.collapse(false);
                    var selection = window.getSelection();
                    selection.removeAllRanges();
                    selection.addRange(range);
                }

            }
        };
    }]);